import { render, staticRenderFns } from "./google-recaptcha-v2.vue?vue&type=template&id=52ff04f0&scoped=true"
import script from "./google-recaptcha-v2.vue?vue&type=script&lang=js"
export * from "./google-recaptcha-v2.vue?vue&type=script&lang=js"
import style0 from "./google-recaptcha-v2.vue?vue&type=style&index=0&id=52ff04f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff04f0",
  null
  
)

export default component.exports